import { render, staticRenderFns } from "./GetPriceListData.vue?vue&type=template&id=254773e8&scoped=true&"
import script from "./GetPriceListData.vue?vue&type=script&lang=js&"
export * from "./GetPriceListData.vue?vue&type=script&lang=js&"
import style0 from "./GetPriceListData.vue?vue&type=style&index=0&id=254773e8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254773e8",
  null
  
)

export default component.exports